import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { JfseIframeEventManagerService } from '@app/shared/modals/jfse/jfse-iframe-modal/services/jfse-iframe-event-manager.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-jfse-iframe-modal',
    templateUrl: './jfse-iframe-modal.component.html',
    styleUrls: ['./jfse-iframe-modal.component.scss'],
})
export class JfseIframeModalComponent implements OnInit, OnDestroy {
    @Input() url: string;
    @Output()
    runRes = new EventEmitter<any>();
    @Output()
    runError = new EventEmitter<any>();
    @ViewChild('iframe', { static: false }) iframe: ElementRef;

    constructor(
        public modalRef: BsModalRef,
        private eventManager: JfseIframeEventManagerService,
        private readonly toastr: ToastrService,
        private readonly translate: TranslateService,
    ) {}

    ngOnInit(): void {
        window.addEventListener('message', (message) =>
            this.eventManager.treatIframeResult(
                message,
                this.runRes,
                this.runError,
            ),
        );

        this.runRes
            .pipe(
                tap((res) => {
                    try {
                        this.toastr.success(
                            this.translate.instant(res as string),
                        );
                    } catch (e) {
                        this.modalRef.hide();
                    }
                    this.modalRef.hide();
                }),
            )
            .subscribe();

        this.runError
            .pipe(
                tap((res) => {
                    this.toastr.error(this.translate.instant(res));
                    this.modalRef.hide();
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        window.removeAllListeners('message');
    }
}
